const checkboxes = (() => {
    const initBlock = el => {
        handleFilters(el);
        handleAllToggle(el);
    };

    const handleFilters = el => {
        const filterWrapper = el.querySelector('[data-checkbox-filter]');
        if (filterWrapper){
            const filter = filterWrapper.querySelector('input');
            filter.addEventListener('input', () => {
                const value = filter.value;
                el.querySelectorAll('[data-checkbox]').forEach(checkbox => {
                    checkbox.classList.remove('flag-wrap__flag--hidden');
                    if (value.length > 2) {
                        if (checkbox.dataset.checkbox.toLowerCase().includes(value.toLowerCase())) {
                            checkbox.classList.remove('flag-wrap__flag--hidden');
                        } else {
                            checkbox.classList.add('flag-wrap__flag--hidden');
                        }
                    }
                });
            });            
        }
    };

    const handleAllToggle = el => {
        const all = el.querySelector('[data-checkbox-all]');
        if (all){
            const checkboxes = el.querySelectorAll('[data-checkbox]');
            all.addEventListener('input', () => {
                const allInput = all.querySelector('input');
                checkboxes.forEach(checkbox => {
                    const checkboxInput = checkbox.querySelector('input');
                    checkboxInput.checked = allInput.checked;
                });
            });            
        }
    };

    return {
        initBlock
    };
})();
ControlBinders.register(`[data-checkboxes]`, el => checkboxes.initBlock(el));